import React, { Component } from "react";
import "../assets/stylus/login.styl";
// redux
import { connect } from "react-redux";
import { setLocaleConfig } from "@/state/action/comAction";

// 国际化
import { injectIntl } from "react-intl";
import ddLogin from "../utils/ddLogin";

@connect((state) => state, { setLocaleConfig })
class Login extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.lang = this.props.appLocalInfo.locale;

    let language = null;
    if (this.props.intl.locale === "zh") {
      language = "中文";
    } else if (this.props.intl.locale === "en") {
      language = "英文";
    } else if (this.props.intl.locale === "es") {
      language = "西班牙语";
    }
    this.state = {
      language: language,
    };
  }

  // 国际化-切换语言

  changeLocale = (lang) => {
    if (lang === "zh") {
      this.setState({
        language: "中文",
      });
      this.props.setLocaleConfig("zh");
      window.sessionStorage.setItem("locale", 'zh');
    } else if (lang === "en") {
      this.setState({
        language: "英文",
      });
      this.props.setLocaleConfig("en");
      window.sessionStorage.setItem("locale", 'zh');
    } else if (lang === "es") {
      this.setState({
        language: "西班牙语",
      });
      this.props.setLocaleConfig("es");
      window.sessionStorage.setItem("locale", 'es');
    }
  };

  // redux
  mapStateToProps = (state) => {
    return {
      prop: state.prop,
    };
  };

  componentDidMount() {
    // this.appid = process.env.doingType === 'buildPro'
    // ? 'dingoazuo5qvl71g8x5p1q' : 'dingoa3delr2571zpjcvai';
    this.appid = process.env.REACT_APP_LOGIN_APPID;
    // https://oms-console.starcharge.com/login.do 外网
    // http://lijiang.test.ccchong.com:8081/login.do 内网
    // this.REDIRECT_URL = process.env.doingType === 'buildPro' ? 'https://oms-console.starcharge.com/login.do' : 'http://oms.api.test.ccchong.com:8086/login.do';
    this.REDIRECT_URL = process.env.REACT_APP_LOGIN_REDIRECT_URL;
    const gotoUrl = encodeURIComponent(
      `https://oapi.dingtalk.com/connect/qrconnect?appid=${this.appid}&response_type=code&scope=snsapi_login&state=STATE&redirect_uri=${this.REDIRECT_URL}`,
    );
    ddLogin.init({
      id: "login_container", // 这里需要你在自己的页面定义一个HTML标签并设置id，例如<div id="login_container"></div>或<span id="login_container"></span>
      goto: gotoUrl,
      style: "border:none;background-color:transparent;",
      width: "300",
      height: "300",
    });
    this.init();
  }

  init() {
    if (typeof window.addEventListener !== "undefined") {
      window.addEventListener("message", this.hanndleMessage, false);
    } else if (typeof window.attachEvent !== "undefined") {
      window.attachEvent("onmessage", this.hanndleMessage);
    }
    window.requestAnimationFrame = window.requestAnimationFrame
      || window.mozRequestAnimationFrame
      || window.webkitRequestAnimationFrame
      || window.msRequestAnimationFrame;

    // let canvas = document.getElementById('canvas');
    // let ctx = canvas.getContext('2d');
    // let w = canvas.width = canvas.offsetWidth;
    // let h = canvas.height = canvas.offsetHeight;
    // let circles = [];
    // let current_circle = new currentCirle(0, 0)

    // let draw = function () {
    //     ctx.clearRect(0, 0, w, h);
    //     for (let i = 0; i < circles.length; i++) {
    //         circles[i].move(w, h);
    //         circles[i].drawCircle(ctx);
    //         for (let j = i + 1; j < circles.length; j++) {
    //             circles[i].drawLine(ctx, circles[j])
    //         }
    //     }
    //     if (current_circle.x) {
    //         current_circle.drawCircle(ctx);
    //         for (var k = 1; k < circles.length; k++) {
    //             current_circle.drawLine(ctx, circles[k])
    //         }
    //     }
    //     requestAnimationFrame(draw)
    // }

    // let init2 = function (num) {
    //     for (var i = 0; i < num; i++) {
    //         circles.push(new Circle(Math.random() * w, Math.random() * h));
    //     }
    //     draw();
    // }
    // window.addEventListener('load', init2(100));
    // window.onmousemove = function (e) {
    //     e = e || window.event;
    //     current_circle.x = e.clientX;
    //     current_circle.y = e.clientY;
    // }
    // window.onmouseout = function () {
    //     current_circle.x = null;
    //     current_circle.y = null;

    // };
  }

  hanndleMessage(event) {
    const origin = event.origin;
    // console.debug("origin", event.origin);
    if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
      const appId = process.env.REACT_APP_LOGIN_APPID;
      const REDIRECT_URL = process.env.REACT_APP_LOGIN_REDIRECT_URL;
      window.location.href = `https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=${appId}&response_type=code&scope=snsapi_auth&state=STATE&redirect_uri=${REDIRECT_URL}`;
    } else if (origin === "https://login.dingtalk.com") {
      // 判断是否来自ddLogin扫码事件。
      const loginTmpCode = event.data; // 拿到loginTmpCode后就可以在这里构造跳转链接进行跳转了
      window.location.href = `https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=${this.appid}&response_type=code&scope=snsapi_login&state=STATE&redirect_uri=REDIRECT_URI&loginTmpCode=${loginTmpCode}`;
    }
  }

  render() {
    // const lanmenu = (
    //     <Menu>
    //         <Menu.Item>
    //             <a onClick = {()=>{this.changeLocale('zh')}}>中文</a>
    //         </Menu.Item>
    //         <Menu.Item>
    //             <a onClick = {()=>{this.changeLocale('en')}} >英文</a>
    //         </Menu.Item>
    //         <Menu.Item>
    //             <a onClick = {()=>{this.changeLocale('es')}} >西班牙语</a>
    //         </Menu.Item>
    //     </Menu>
    // );

    // const internationalization = this.props.intl.messages.newLogin;
    const LoginDom = (
      <div className="loginWrap">
        <div className="loginHeader">
          <div className="companyIcon">
            <div className="companyIconItem"></div>
            <span className="fengge">|</span>
            <span className="sysName">智能运维系统</span>
          </div>

          <div className="changeLanguage">
            {/* <div className = "location">{this.state.location}</div> */}

            {/* <Dropdown overlay={lanmenu}> */}
            {/*    <Button
                className = "languageDropDown"
                 style = {{'zIndex' : '100'}}  href="javascript:void(0)"> */}
            {/*        <span className={'username'}>{this.state.language}</span> */}
            {/*        <Icon type={'down'}></Icon> */}
            {/*    </Button> */}
            {/* </Dropdown> */}
          </div>
        </div>
        <div className="login-box">
          {/* <div className="login-title">
                        <img src={loginLogo} className="App-logo" alt="logo"/>
                    </div> */}
          <div id="login_container"></div>
          <div className="bg"></div>
          {/* <div style={{height:150}}></div> */}
        </div>
        <div className="sc-oms-footer-login" style={{ lineHeight: "20px" }}>
          COPYRIGHT &copy;2018 万帮星星充电科技有限公司 All rights reserved.
          <br />{" "}
          <a
            style={{ color: "#fff" }}
            onClick={() => {
              window.open("http://beian.miit.gov.cn/");
            }}
          >
            苏ICP备14056214号-3{" "}
          </a>{" "}
          版本号：{process.env.REACT_APP_VERSION}
        </div>
        <canvas className="login-bg" id="canvas"></canvas>
      </div>
    );
    return LoginDom;
  }
}

export default injectIntl(Login);



// WEBPACK FOOTER //
// ./src/AntD/pages/login.js